import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E8E] py-8">
      <div className="max-w-6xl mx-auto px-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer hover:opacity-90 transition-opacity">
            <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
              <i className="ri-home-smile-line text-white text-lg"></i>
            </div>
            <span className="font-bold text-white">IVision Virtual Staging</span>
          </Link>
          
          {/* Copyright */}
          <p className="text-white/80 text-sm">
            © {currentYear} IVision Virtual Staging. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
